import {MerchantSDKSettings} from "../merchant/MerchantSDKSettingsStore";
import {type StoreClass, StoreObject} from "../../../stem-core/state/Store";
import {type RawStoreObject, type StoreEvent, type StoreIdOrNull} from "../../../stem-core/state/State";
import {MerchantSDKResource} from "./MerchantSDKResource";
import {Merchant} from "../MerchantStore";

/* TODO @branch @cleanup Remove this in the future.
    this is required because the ws server does not guarantee the order of
    subscription status updates - ACTIVE status may be received before
    PENDING
*/
export class PaymentStatusDependentStore extends StoreObject {
    static importState(objects: RawStoreObject[]): void {
        objects = objects || [];
        for (const obj of objects) {
            const subscription = this.get(obj.id);
            if (!this.shouldSkipUpdate(subscription, obj)) {
                super.importState([obj]);
            }
        }
    }

    // Left open: typing this as the base does (`this: StoreClass<T>`) drops the class's own statics, so
    // shouldSkipUpdate below stops resolving, and super's answer is no longer T
    static applyEvent(event: StoreEvent): any {
        const obj = this.getObjectForEvent(event);

        if (this.shouldSkipUpdate(obj, event.data)) {
            event.data = obj;
        }
        return super.applyEvent(event);
    }

    // The stored object as it is now, and whatever the event or the imported state carries for it
    static shouldSkipUpdate(obj: StoreObject | undefined, updateObj: StoreEvent["data"]): boolean {
        return !updateObj;
    }
}


// Since multiple objects might have been created on a version fork, we'll find the one we edited by the parent id
export function loadVersionedObjectFromResponse<T extends MerchantSDKResource>(store: StoreClass<T>, response: any, expectedParentId: StoreIdOrNull): T | undefined {
    const objects = store.load(response);
    if (objects.length <= 1) {
        return objects[0];
    }
    // We forked the published version of merchant settings with this request
    const sdkSettingsVersion = MerchantSDKSettings.loadObject(response);
    // Find the object that is part of the forked settings and has the expected
    // version parent.
    return objects.find(obj => obj.settingsVersion === sdkSettingsVersion && obj.parentId == expectedParentId);
}
